import React from 'react';
import PropTypes from 'prop-types';
import { Cushion, Typography } from '@pitchero/react-ui';
import { Trans } from '../../lib/i18n';
import TEAM_PROP_TYPES from '../../lib/prop-types/team';
import ClubLink from '../club-link';
import ClearFilterButton from '../navigation/clear-filter-button';
import UploadButton from './upload-button';

const NoResults = ({ mediaType, team, search }) => {
  if (!team && search.length === 0) {
    return (
      <Cushion
        all="large"
        component="div"
        style={{ maxWidth: 280, margin: '0 auto', textAlign: 'center' }}
      >
        <Cushion bottom="medium">
          <Typography preset="subtitle--large" component="div">
            <Trans i18nKey={`media:no_${mediaType}_results`}>
              {`Sorry, there aren’t any ${mediaType} to show`}
            </Trans>
          </Typography>
        </Cushion>
        <Cushion bottom="medium">
          <Typography preset="body--small" color="dovegrey" component="div">
            <Trans i18nKey={`media:no_${mediaType}_results_description`}>
              If you have photos of this club, why not upload them?
            </Trans>
          </Typography>
        </Cushion>
        <UploadButton mediaType={mediaType} />
      </Cushion>
    );
  }

  const clearSearchRoute = team ? `media.${mediaType}.team` : `media.${mediaType}`;
  const clearSearchParams = team ? { teamId: team.id } : {};
  const clearTeamParams = search.length ? { search } : {};

  return (
    <Cushion
      all="large"
      component="div"
      style={{ maxWidth: 300, margin: '0 auto', textAlign: 'center' }}
    >
      {search && (
        <ClearFilterButton label={search} route={clearSearchRoute} params={clearSearchParams} />
      )}
      {team && (
        <ClearFilterButton
          label={team.name}
          route={`media.${mediaType}`}
          params={clearTeamParams}
        />
      )}
      <Cushion bottom="medium">
        <Typography preset="subtitle--large" component="div">
          <Trans i18nKey={`media:no_filtered_${mediaType}_results`}>
            {`Sorry, there aren’t any ${mediaType} that match your filters`}
          </Trans>
        </Typography>
      </Cushion>
      <Cushion bottom="medium">
        <Typography preset="body--small" color="dovegrey" component="div">
          <Trans i18nKey="common:no_filtered_results_advice">
            Try changing or clearing your filters
          </Trans>
        </Typography>
      </Cushion>
      <ClubLink route={`media.${mediaType}`}>
        <a>
          <Typography preset="button" color="primary">
            <Trans i18nKey="common:clear_all_filters_cta">Clear all filters</Trans>
          </Typography>
        </a>
      </ClubLink>
    </Cushion>
  );
};

NoResults.defaultProps = {
  team: null,
  search: '',
};

NoResults.propTypes = {
  mediaType: PropTypes.string.isRequired,
  search: PropTypes.string,
  team: TEAM_PROP_TYPES,
};

export default NoResults;
